import { Box } from '@material-ui/core';
import React from 'react';
import { Tooltip } from 'styleguide';

export default function CroppedText({ value, length = 20 }) {
  if (value?.length > length) {
    return <Tooltip title={<Box whiteSpace="pre-line">{value}</Box>} label={`${value.substring(0, length)}...`} />;
  }
  return value || null;
}